import Button from 'components/Button/Button';
import {useGlobalState} from 'hooks/useGlobalState';
import {useDispatch} from 'react-redux';
import {setModalAC} from 'store/modal/modalSlice';
import {unassignPubACS} from 'store/singlePageEditor/requestAC';

import './UnassignPub.scss';

const UnassignPub = () => {
  const unassignPubData = useGlobalState((state) => state.singlePageEditor.unassignPubData);

  const dispatch = useDispatch();

  const handleClose = () => {
    dispatch(setModalAC(null));
  };

  const handleRemovePub = () => {
    if (!unassignPubData) return;

    dispatch(
      unassignPubACS({
        editorId: unassignPubData.editorId,
        pubId: unassignPubData.pubId,
        assignedPubId: unassignPubData.assignedPubId,
      }),
    );

    handleClose();
  };

  if (!unassignPubData) return null;

  return (
    <div className="remove-pub">
      <h1 className="remove-pub__title">Remove pub page?</h1>
      <p className="remove-pub__description">
        Are you sure you want to remove pub’s page{' '}
        <span className="remove-pub__pub-name">{unassignPubData.pubName}</span> from{' '}
        <span className="remove-pub__editor-name">{unassignPubData.editorName}</span> managed pubs list?
      </p>
      <div className="remove-pub__actions">
        <Button onClick={handleClose} className="remove-pub__cancel" variant="tertiary-outlined">
          Cancel
        </Button>
        <Button onClick={handleRemovePub} className="remove-pub__remove" variant="tertiary">
          Remove Pub
        </Button>
      </div>
    </div>
  );
};

export default UnassignPub;
